import * as React from 'react';
import { connect } from 'react-redux';
import {
    Modal,
    Button,
    FormControl,
    FormGroup,
    ControlLabel,
    Checkbox,
    HelpBlock,
    Tab,
    Nav,
    NavItem
} from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import * as brokerAgentActions from '../actions/BrokerAgentActions';
import * as BrokerTreeTypes from '../BrokerTreeTypes';
import { assign } from '../../../shared/Assign';
import notify from '../../../shared/feedback/notifications';
import { handleError } from '../../../shared/ErrorCatching';
import FormInputChangeHandler from '../../../shared/form/FormInputChangeHandler';
import FormValidationService from '../../../shared/form/FormValidationService';
import LanguageSelect from '../../../components/common/LanguageSelect';
import FormSelect from '../../../components/common/FormSelect';
import BrokerFirmList from './BrokerFirmList';
import ConfirmationModal from '../../../components/common/ConfirmationModal';
import { getActivationOutcome } from './activationResult';
import { getMailedToAddress, getPasswordLinkOutcome } from './passwordLinkResult';
import { copyToClipboard } from './copyToClipboard';
import FieldInfoIcon from '../../../components/common/FieldInfoIcon';
import * as Features from '../../../shared/Features';
import CountryCodePhoneNumberInput from '../../../components/common/CountryCodePhoneNumberInput';
import { getSiteName } from '../../../shared/Site';
import * as Site from '../../../shared/Site';

class AgentModal extends React.Component<any, any> {
    formInputChangeHandler: FormInputChangeHandler;
    passwordLinkInput: HTMLInputElement | null = null;

    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            wasMoved: false,
            agent: {
                type: BrokerTreeTypes.Agent,
                parentId: props.item.parentId,
                firms: [],
                languageKey: 'sv',
                name: '',
                isSe360: true,
                procountorId: '',
                sendActivationEmail: true
            },
            errors: {},
            creating: false,
            createdPasswordLink: null,
            activationFailed: false,
            passwordLink: null,
            passwordLinkBusy: false,
            passwordLinkConfirm: null,
            availableFirms: [],
            headOfficeTitle: '-',
            showSE360: true,
            showScandphotos: true,
            availableHeadFirms: []
        };

        this.closeModal = this.closeModal.bind(this);
        this.save = this.save.bind(this);
        this.copyPasswordLink = this.copyPasswordLink.bind(this);
        this.sendPasswordEmail = this.sendPasswordEmail.bind(this);
        this.showPasswordLink = this.showPasswordLink.bind(this);
        this.dismissPasswordLink = this.dismissPasswordLink.bind(this);
        this.confirmPasswordLink = this.confirmPasswordLink.bind(this);
        this.closePasswordLinkConfirm = this.closePasswordLinkConfirm.bind(this);
        this.setAgentState = this.setAgentState.bind(this);
        this.addFirm = this.addFirm.bind(this);
        this.removeFirm = this.removeFirm.bind(this);
        this.headOfficeChanged = this.headOfficeChanged.bind(this);
        this.setNewAvaibleFirms = this.setNewAvaibleFirms.bind(this);
        this.setTitleOffice = this.setTitleOffice.bind(this);
        this.setVisibleSites = this.setVisibleSites.bind(this);

        this.formInputChangeHandler = new FormInputChangeHandler(
            this.state.agent,
            this.setAgentState
        );
    }

    setAgentState(newAgent: any) {
        this.setState({ agent: newAgent });
    }

    setVisibleSites() {
        let showSE360 = true,
            showScandphotos = true;
        if (this.props.allowedSites) {
            showSE360 = this.props.allowedSites.sE360;
            showScandphotos = this.props.allowedSites.scandphotos;
        }
        if (this.props.site === getSiteName(Site.Zentuvo)) {
            showScandphotos = false;
        }
        this.setState({
            showSE360: showSE360,
            showScandphotos: showScandphotos
        });
    }

    componentDidMount() {
        if (FormValidationService.isEdit(this.props.item.id)) {
            this.props.actions
                .editBrokerAgent(this.props.item.id)
                .then(() => {
                    let headOfficeTitle = this.props.parentFirm
                        ? this.props.parentFirm.parentFirmName
                        : '-';
                    this.setState({ headOfficeTitle });
                    let agent = assign({}, this.props.agent);
                    agent.parentFirm = assign({}, this.props.parentFirm);
                    agent.parentFirmId = parseInt(this.props.parentFirm.parentFirmId);
                    this.formInputChangeHandler.updateObj(agent);
                    this.setAgentState(agent);
                    let availableFirms = assign([], this.props.availableFirms);
                    let allowedListFirms = this.props.allowedListFirms;
                    if (allowedListFirms) {
                        this.setState({
                            availableHeadFirms: assign([], allowedListFirms)
                        });
                        availableFirms = availableFirms.filter(
                            (x) => allowedListFirms.map((y) => y.id).indexOf(x.id) !== -1
                        );
                    } else {
                        this.setState({
                            availableHeadFirms: assign([], this.props.availableFirms)
                        });
                    }
                    this.setVisibleSites();
                    this.setState({ availableFirms: availableFirms });
                })
                .catch((error: any) => {
                    notify.failure(error);
                });
        } else {
            this.props.actions
                .newBrokerAgent(this.props.item.parentId)
                .then(() => {
                    if (this.props.parentFirm) {
                        this.setTitleOffice(this.props.parentFirm.parentFirmId);
                    }
                    let availableFirms = assign([], this.props.availableFirms);
                    this.setVisibleSites();
                    this.setState({ availableFirms: availableFirms });
                    if (this.props.parentFirm) {
                        let parent = assign(
                            {},
                            {
                                id: parseInt(this.props.parentFirm.parentFirmId),
                                name: this.props.parentFirm.parentFirmName
                            }
                        );
                        let agent = { ...this.state.agent };
                        agent.parentFirm = {
                            parentFirmId: parseInt(this.props.parentFirm.parentFirmId),
                            parentFirmName: this.props.parentFirm.parentFirmName
                        };
                        agent.parentFirmId = parseInt(agent.parentFirm.parentFirmId);
                        let availableHeadFirms = [parent];
                        this.setState({
                            availableHeadFirms: availableHeadFirms
                        });
                        this.formInputChangeHandler.updateObj(agent);
                        this.setAgentState(agent);
                    } else {
                        this.setState({
                            availableHeadFirms: assign([], availableFirms)
                        });
                    }
                })
                .catch((error: any) => {
                    notify.failure(error);
                });
        }
    }

    render() {
        if (this.state.createdPasswordLink) {
            return this.renderPasswordLink();
        }

        if (this.state.activationFailed) {
            return this.renderActivationFailed();
        }

        if (this.state.passwordLink) {
            return this.renderExistingAgentPasswordLink();
        }

        return (
            <Modal show={true} onHide={this.closeModal} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {FormValidationService.isEdit(this.props.item.id) && this.props.parentFirm
                            ? Translate('broker-agent/form/edit/title').concat(
                                  this.state.headOfficeTitle
                              ) +
                              (this.state.agent.name ? ': ' : '') +
                              this.state.agent.name
                            : Translate('broker-agent/form/create/title').concat(
                                  this.state.headOfficeTitle
                              )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tab.Container defaultActiveKey={1} id="uncontrolled-tab">
                        <div>
                            <Nav>
                                <NavItem eventKey={1}>
                                    {Translate('broker-agent/form/tab/user')}
                                    {FormValidationService.setTabValidationError(
                                        this.state.errors,
                                        'name',
                                        'username',
                                        'email',
                                        'phoneNumber',
                                        'role',
                                        'languageKey'
                                    )}
                                </NavItem>
                                <NavItem eventKey={2}>
                                    {Translate('broker-agent/form/tab/other')}
                                    {FormValidationService.setTabValidationError(
                                        this.state.errors,
                                        'isScandphotos',
                                        'isSe360',
                                        'select-system-type'
                                    )}
                                </NavItem>
                                <NavItem eventKey={3}>
                                    {Translate('broker-agent/form/tab/firm-connections')}
                                    {FormValidationService.setTabValidationError(
                                        this.state.errors,
                                        'parentFirmId'
                                    )}
                                </NavItem>
                            </Nav>

                            <Tab.Content>
                                <Tab.Pane eventKey={1}>
                                    <fieldset>
                                        <legend>{Translate('broker-agent/form/tab/user')}</legend>
                                        <FormGroup
                                            className="required"
                                            validationState={FormValidationService.getValidationState(
                                                this.state.errors.name
                                            )}
                                        >
                                            <ControlLabel>
                                                {Translate('broker-agent/form/user/name')}
                                            </ControlLabel>
                                            <FormControl
                                                autoFocus
                                                type="text"
                                                name="name"
                                                value={
                                                    this.state.agent.name
                                                        ? this.state.agent.name
                                                        : ''
                                                }
                                                onChange={this.formInputChangeHandler.onChange}
                                            />
                                            <HelpBlock>{this.state.errors.name}</HelpBlock>
                                        </FormGroup>
                                        <FormGroup
                                            className="required"
                                            validationState={FormValidationService.getValidationState(
                                                this.state.errors.username
                                            )}
                                        >
                                            <ControlLabel>
                                                {Translate('broker-agent/form/user/username')}
                                            </ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="username"
                                                value={
                                                    this.state.agent.username
                                                        ? this.state.agent.username
                                                        : ''
                                                }
                                                onChange={this.formInputChangeHandler.onChange}
                                            />
                                            <HelpBlock>{this.state.errors.username}</HelpBlock>
                                        </FormGroup>
                                        <FormGroup
                                            className="required"
                                            validationState={FormValidationService.getValidationState(
                                                this.state.errors.email
                                            )}
                                        >
                                            <ControlLabel>
                                                {Translate('broker-agent/form/user/email-address')}
                                            </ControlLabel>
                                            <FormControl
                                                type="email"
                                                name="email"
                                                value={
                                                    this.state.agent.email
                                                        ? this.state.agent.email
                                                        : this.state.agent.username
                                                }
                                                onChange={this.formInputChangeHandler.onChange}
                                            />
                                            <HelpBlock>{this.state.errors.email}</HelpBlock>
                                        </FormGroup>
                                        <FormGroup
                                            validationState={FormValidationService.getValidationState(
                                                this.state.errors.deliveryEmail
                                            )}
                                        >
                                            <ControlLabel>
                                                {Translate('broker-agent/form/delivery-email')}
                                            </ControlLabel>
                                            <FormControl
                                                type="email"
                                                name="extraEmailRecipients"
                                                value={
                                                    this.state.agent.extraEmailRecipients
                                                        ? this.state.agent.extraEmailRecipients
                                                        : ''
                                                }
                                                onChange={this.formInputChangeHandler.onChange}
                                            />
                                            <HelpBlock>{this.state.errors.deliveryEmail}</HelpBlock>
                                        </FormGroup>
                                        <FormGroup
                                            validationState={FormValidationService.getValidationState(
                                                this.state.errors.phoneNumber
                                            )}
                                        >
                                            <ControlLabel>
                                                {Translate('broker-agent/form/primary-phone-number')}
                                            </ControlLabel>
                                            <FieldInfoIcon
                                                title={Translate('popover/info/title/phonenumber')}
                                                content={Translate(
                                                    'popover/info/content/phonenumber'
                                                )}
                                            />
                                            <CountryCodePhoneNumberInput
                                                value={
                                                    this.state.agent.phoneNumber
                                                        ? this.state.agent.phoneNumber
                                                        : ''
                                                }
                                                onChange={(val) =>
                                                    this.formInputChangeHandler.onChange({
                                                        target: {
                                                            name: 'phoneNumber',
                                                            value: val
                                                        }
                                                    })
                                                }
                                            />
                                            <HelpBlock>{this.state.errors.phoneNumber}</HelpBlock>
                                        </FormGroup>
                                        <FormGroup
                                            validationState={FormValidationService.getValidationState(
                                                this.state.errors.mobileNumber
                                            )}
                                        >
                                            <ControlLabel>
                                                {Translate('broker-agent/form/secondary-phone-number')}
                                            </ControlLabel>
                                            <FieldInfoIcon
                                                title={Translate('popover/info/title/phonenumber')}
                                                content={Translate(
                                                    'popover/info/content/phonenumber'
                                                )}
                                            />
                                            <CountryCodePhoneNumberInput
                                                value={
                                                    this.state.agent.mobileNumber
                                                        ? this.state.agent.mobileNumber
                                                        : ''
                                                }
                                                onChange={(val) =>
                                                    this.formInputChangeHandler.onChange({
                                                        target: {
                                                            name: 'mobileNumber',
                                                            value: val
                                                        }
                                                    })
                                                }
                                            />

                                            <HelpBlock>{this.state.errors.mobileNumber}</HelpBlock>
                                        </FormGroup>
                                        <LanguageSelect
                                            onChange={this.formInputChangeHandler.onChange}
                                            languageKey={
                                                this.state.agent.languageKey
                                                    ? this.state.agent.languageKey
                                                    : 0
                                            }
                                            languages={this.props.availableLanguages}
                                            errors={this.state.errors}
                                        />
                                        <FormGroup
                                            className="required"
                                            validationState={FormValidationService.getValidationState(
                                                this.state.errors.role
                                            )}
                                        >
                                            <ControlLabel>
                                                {Translate('broker-agent/form/user/role')}
                                            </ControlLabel>
                                            <div className="select-div">
                                                <FormSelect
                                                    disabled={
                                                        this.props.user.details.id ===
                                                        this.state.agent.id
                                                    }
                                                    name="role"
                                                    value={this.state.agent.role}
                                                    onChange={this.formInputChangeHandler.onChange}
                                                    defaultTranslateKey="broker-agent/form/user/role-default-option"
                                                >
                                                    {this.props.userRoles.map((x: any) => {
                                                        return (
                                                            <option value={x.id} key={x.id}>
                                                                {Translate(x.name)}
                                                            </option>
                                                        );
                                                    })}
                                                </FormSelect>
                                            </div>
                                            <HelpBlock>{this.state.errors.role}</HelpBlock>
                                        </FormGroup>
                                    </fieldset>
                                </Tab.Pane>
                                <Tab.Pane eventKey={2}>
                                    <fieldset>
                                        <legend>{Translate('broker-agent/form/tab/other')}</legend>
                                        {this.state.showScandphotos && (
                                            <FormGroup
                                                validationState={FormValidationService.getValidationState(
                                                    this.state.errors.isScandphotos
                                                )}
                                            >
                                                <Checkbox
                                                    inline
                                                    name="isScandphotos"
                                                    checked={
                                                        this.state.agent.isScandphotos
                                                            ? this.state.agent.isScandphotos
                                                            : false
                                                    }
                                                    onChange={this.formInputChangeHandler.onChange}
                                                    disabled={
                                                        this.props.user.details.id ===
                                                        this.state.agent.id
                                                    }
                                                >
                                                    <span>
                                                        {Translate(
                                                            'broker-agent/form/is-scandphotos'
                                                        )}
                                                    </span>
                                                </Checkbox>
                                            </FormGroup>
                                        )}
                                        {this.state.showSE360 && (
                                            <FormGroup
                                                validationState={FormValidationService.getValidationState(
                                                    this.state.errors.isSe360
                                                )}
                                            >
                                                <Checkbox
                                                    inline
                                                    name="isSe360"
                                                    checked={
                                                        this.state.agent.isSe360
                                                            ? this.state.agent.isSe360
                                                            : false
                                                    }
                                                    onChange={this.formInputChangeHandler.onChange}
                                                    disabled={
                                                        this.props.user.details.id ===
                                                        this.state.agent.id
                                                    }
                                                >
                                                    <span>
                                                        {Translate('broker-agent/form/is-se360')}
                                                    </span>
                                                </Checkbox>
                                            </FormGroup>
                                        )}
                                        <FormGroup
                                            validationState={FormValidationService.getValidationState(
                                                this.state.errors.procountorId
                                            )}
                                        >
                                            <ControlLabel>
                                                {Translate('broker-agent/form/procountor-id')}
                                            </ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="procountorId"
                                                value={this.state.agent.procountorId || ''}
                                                onChange={(e) => {
                                                    const value = (e.target as HTMLInputElement).value;
                                                    if (/^\d{0,10}$/.test(value)) {
                                                        this.formInputChangeHandler.onChange(e);
                                                    }
                                                }}
                                            />
                                            <HelpBlock>{this.state.errors.procountorId}</HelpBlock>
                                        </FormGroup>
                                        {!FormValidationService.isEdit(this.props.item.id) && (
                                            <FormGroup>
                                                <Checkbox
                                                    inline
                                                    name="sendActivationEmail"
                                                    checked={
                                                        this.state.agent.sendActivationEmail
                                                            ? this.state.agent.sendActivationEmail
                                                            : false
                                                    }
                                                    onChange={this.formInputChangeHandler.onChange}
                                                >
                                                    <span>
                                                        {Translate(
                                                            'broker-agent/form/send-activation-email'
                                                        )}
                                                    </span>
                                                </Checkbox>
                                                <HelpBlock>
                                                    {Translate(
                                                        'broker-agent/form/send-activation-email/help'
                                                    )}
                                                </HelpBlock>
                                            </FormGroup>
                                        )}
                                        {FormValidationService.isEdit(this.props.item.id) &&
                                            Features.hasFeature(
                                                Features.SendAgentPasswordLink,
                                                this.props.user
                                            ) && (
                                            <FormGroup>
                                                <ControlLabel>
                                                    {Translate(
                                                        'broker-agent/password-link/section-title'
                                                    )}
                                                </ControlLabel>
                                                <div>
                                                    <Button
                                                        disabled={this.state.passwordLinkBusy}
                                                        onClick={this.sendPasswordEmail}
                                                    >
                                                        {Translate(
                                                            'broker-agent/password-link/send-email'
                                                        )}
                                                    </Button>{' '}
                                                    <Button
                                                        disabled={this.state.passwordLinkBusy}
                                                        onClick={this.showPasswordLink}
                                                    >
                                                        {Translate(
                                                            'broker-agent/password-link/get-link'
                                                        )}
                                                    </Button>
                                                </div>
                                                <HelpBlock style={{ marginTop: 10 }}>
                                                    {Translate(
                                                        'broker-agent/password-link/existing-help'
                                                    )}
                                                </HelpBlock>
                                            </FormGroup>
                                        )}
                                    </fieldset>
                                </Tab.Pane>
                                <Tab.Pane eventKey={3}>
                                    <fieldset>
                                        <legend>
                                            {Translate('broker-agent/form/tab/firm-connections')}
                                        </legend>
                                        <FormGroup
                                            className="required"
                                            validationState={FormValidationService.getValidationState(
                                                this.state.errors.parentFirmId
                                            )}
                                        >
                                            <ControlLabel>
                                                {Translate('broker-agent/form/head-office').concat(
                                                    ':'
                                                )}
                                            </ControlLabel>
                                            <div className="select-div">
                                                <FormSelect
                                                    disabled={
                                                        !Features.hasFeature(
                                                            Features.EditHeadOffice,
                                                            this.props.user
                                                        ) ||
                                                        this.props.user.details.id ===
                                                            this.state.agent.id
                                                    }
                                                    name="role"
                                                    value={
                                                        this.state.agent.parentFirm
                                                            ? this.state.agent.parentFirm
                                                                  .parentFirmId
                                                            : -1
                                                    }
                                                    onChange={this.headOfficeChanged}
                                                    defaultTranslateKey="broker-agent/form/user/head-office-default-option"
                                                >
                                                    {this.state.availableHeadFirms &&
                                                        this.state.availableHeadFirms
                                                            .sort((a, b) => {
                                                                if (a.name < b.name) {
                                                                    return -1;
                                                                }
                                                                if (a.name > b.name) {
                                                                    return 1;
                                                                }

                                                                return 0;
                                                            })
                                                            .map((x: any) => {
                                                                return (
                                                                    <option value={x.id} key={x.id}>
                                                                        {x.name}
                                                                    </option>
                                                                );
                                                            })}
                                                </FormSelect>
                                            </div>
                                            <HelpBlock>{this.state.errors.parentFirmId}</HelpBlock>
                                        </FormGroup>
                                        <BrokerFirmList
                                            availableFirms={this.state.availableFirms}
                                            firms={this.state.agent.firms}
                                            add={this.addFirm}
                                            remove={this.removeFirm}
                                        />
                                    </fieldset>
                                </Tab.Pane>
                            </Tab.Content>
                        </div>
                    </Tab.Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.closeModal}>
                        {Translate('broker-agent/modal/footer/button-label/close')}
                    </Button>
                    <Button disabled={this.state.creating} bsStyle="primary" onClick={this.save}>
                        {Translate('broker-agent/modal/footer/button-label/save')}
                    </Button>
                </Modal.Footer>
                {this.state.passwordLinkConfirm && this.renderPasswordLinkConfirmation()}
            </Modal>
        );
    }

    renderPasswordLink() {
        return this.renderPasswordLinkPanel(
            'broker-agent/password-link/title',
            'broker-agent/password-link/help',
            this.state.createdPasswordLink,
            this.closeModal
        );
    }

    renderExistingAgentPasswordLink() {
        return this.renderPasswordLinkPanel(
            'broker-agent/password-link/existing-title',
            'broker-agent/password-link/existing-link-help',
            this.state.passwordLink,
            this.dismissPasswordLink
        );
    }

    renderPasswordLinkPanel(
        titleKey: string,
        helpKey: string,
        link: string,
        onConfirm: () => void
    ) {
        /*
         * The link is shown once and cannot be retrieved again, so this panel deliberately has
         * no close button, no backdrop click and no ESC - only the explicit confirm button.
         */
        return (
            <Modal
                show={true}
                onHide={onConfirm}
                backdrop="static"
                keyboard={false}
                bsSize="large"
            >
                <Modal.Header>
                    <Modal.Title>{Translate(titleKey)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormGroup>
                        <ControlLabel>
                            {Translate('broker-agent/password-link/label')}
                        </ControlLabel>
                        <FormControl
                            type="text"
                            readOnly
                            value={link}
                            inputRef={(input: HTMLInputElement) => {
                                this.passwordLinkInput = input;
                            }}
                            onFocus={(e: any) => e.target.select()}
                        />
                        <HelpBlock style={{ marginTop: 10 }}>{Translate(helpKey)}</HelpBlock>
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.copyPasswordLink}>
                        {Translate('broker-agent/password-link/copy')}
                    </Button>
                    <Button bsStyle="primary" onClick={onConfirm}>
                        {Translate('broker-agent/password-link/confirm-close')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    renderActivationFailed() {
        /*
         * The agent was created but has no way in and was told nothing. Same static backdrop as the
         * link panel - this must be read and acknowledged, not clicked away by accident.
         */
        return (
            <Modal
                show={true}
                onHide={this.closeModal}
                backdrop="static"
                keyboard={false}
                bsSize="large"
            >
                <Modal.Header>
                    <Modal.Title>{Translate('broker-agent/no-way-in/title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        <strong>{Translate('broker-agent/no-way-in/summary')}</strong>
                    </p>
                    <p>{Translate('broker-agent/no-way-in/what-to-do')}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="primary" onClick={this.closeModal}>
                        {Translate('broker-agent/no-way-in/confirm-close')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    copyPasswordLink() {
        let link = this.state.createdPasswordLink || this.state.passwordLink;

        copyToClipboard(link, this.passwordLinkInput).then((copied: boolean) => {
            if (copied) {
                notify.success(Translate('broker-agent/password-link/copied'));
            } else {
                notify.warning(Translate('broker-agent/password-link/copy-failed'));
            }
        });
    }

    sendPasswordEmail() {
        this.setState({ passwordLinkConfirm: 'email' });
    }

    showPasswordLink() {
        this.setState({ passwordLinkConfirm: 'link' });
    }

    closePasswordLinkConfirm() {
        this.setState({ passwordLinkConfirm: null });
    }

    confirmPasswordLink() {
        this.requestPasswordLink(this.state.passwordLinkConfirm === 'email');
    }

    renderPasswordLinkConfirmation() {
        let sendMail = this.state.passwordLinkConfirm === 'email';

        return (
            <ConfirmationModal
                title={Translate('broker-agent/password-link-confirmation/title')}
                text={Translate(
                    sendMail
                        ? 'broker-agent/password-link-confirmation/text-email'
                        : 'broker-agent/password-link-confirmation/text-link'
                )}
                doButtonLabel={Translate(
                    'broker-agent/password-link-confirmation/button-labels/create'
                )}
                cancelButtonLabel={Translate(
                    'broker-agent/password-link-confirmation/button-labels/cancel'
                )}
                doButtonStyle="danger"
                do={this.confirmPasswordLink}
                closeModal={this.closePasswordLinkConfirm}
            />
        );
    }

    dismissPasswordLink() {
        this.setState({ passwordLink: null });
    }

    requestPasswordLink(sendMail: boolean) {
        this.setState({ passwordLinkBusy: true });

        this.props.actions
            .sendAgentPasswordLink(this.state.agent.id, sendMail)
            .then((result: any) => {
                this.setState({ passwordLinkBusy: false });

                let outcome = getPasswordLinkOutcome(result);

                if (outcome === 'show-link') {
                    this.setState({ passwordLink: result.passwordLink });
                    return;
                }

                if (outcome === 'email-sent') {
                    let mailedTo = getMailedToAddress(result);

                    notify.success(
                        mailedTo
                            ? Translate('broker-agent/password-link/email-sent', {
                                  email: mailedTo
                              })
                            : Translate('broker-agent/password-link/email-sent-unknown-address')
                    );
                    return;
                }

                notify.warning(Translate('broker-agent/password-link/error'));
            })
            .catch((errorResponse: any) => {
                this.setState({ passwordLinkBusy: false });
                handleError(errorResponse);
            });
    }

    addFirm(value: any) {
        let item = this.state.availableFirms.find((firm: any) => {
            return firm.id.toString() === value.toString();
        });

        let agent = assign({}, this.state.agent);
        agent.firms.push(item);
        this.formInputChangeHandler.updateObj(agent);
        this.setAgentState(agent);
    }

    removeFirm(index: number) {
        let agent = assign({}, this.state.agent);
        agent.firms.splice(index, 1);
        this.formInputChangeHandler.updateObj(agent);
        this.setAgentState(agent);
    }

    setTitleOffice(officeId: number) {
        if (this.props.allowedListFirms) {
            let office = this.props.allowedListFirms.filter(
                (allowedFirm: any) => officeId && allowedFirm.id.toString() === officeId.toString()
            );

            if (office && office.length === 1) {
                this.setState({ headOfficeTitle: office[0].name });
            } else {
                this.setState({ headOfficeTitle: '-' });
            }
        } else {
            this.setState({
                headOfficeTitle: this.props.parentFirm.parentFirmName
            });
        }
    }

    headOfficeChanged(e: any) {
        this.setState({ wasMoved: true });
        let agent = assign({}, this.state.agent);
        let newHeadOfficeId = e.target.value;
        this.setTitleOffice(newHeadOfficeId);
        agent.parentFirm = assign(
            {},
            this.props.availableFirms.find((x: any) => x.id === parseInt(newHeadOfficeId))
        );
        agent.parentFirmId = parseInt(newHeadOfficeId);

        let index = agent.firms.findIndex((firm: any) => {
            return firm.id.toString() === e.target.value.toString();
        });
        if (index !== -1) {
            agent.firms.splice(index, 1);
        }

        this.setNewAvaibleFirms(newHeadOfficeId);
        this.formInputChangeHandler.updateObj(agent);
        this.setAgentState(agent);
    }

    setNewAvaibleFirms(firmToRemove: any) {
        let newAvailableFirms = (this.props.allowedListFirms || this.props.availableFirms).filter(
            (x) => x.id.toString() !== firmToRemove
        );
        this.setState({ availableFirms: newAvailableFirms });
    }

    save() {
        this.setState({ creating: true });
        if (FormValidationService.isEdit(this.props.item.id)) {
            this.update();
        } else {
            this.checkForEmail();
            this.create();
        }
    }

    checkForEmail() {
        let agent = this.state.agent;

        if (!agent.email && agent.username) {
            agent.email = agent.username;

            this.setState({ agent: assign({}, agent) });
        }
    }

    create() {
        let agent = assign({}, this.state.agent);

        agent.firms = agent.firms.map((firm: any) => {
            return firm.id;
        });

        if (this.props.isFromList) {
            this.props.actions
                .createListBrokerAgent(agent)
                .then((result: any) => {
                    this.onCreateSuccess(result);
                })
                .catch((errorResponse: any) => {
                    handleError(errorResponse, (errors) => {
                        this.setState({ errors: errors, creating: false });
                    });
                });
        } else {
            agent.parentFirm = this.props.parentFirm;
            this.props.actions
                .createBrokerAgent(agent)
                .then((result: any) => {
                    this.onCreateSuccess(result);
                })
                .catch((errorResponse: any) => {
                    handleError(errorResponse, (errors) => {
                        this.setState({ errors: errors, creating: false });
                    });
                });
        }
    }

    onCreateSuccess(result: any) {
        this.setState({ creating: false });

        if (typeof this.props.onCreated === 'function') {
            this.props.onCreated();
        }

        let outcome = getActivationOutcome(result);

        if (outcome === 'show-link') {
            notify.success(Translate('broker-agent/create-message'));
            this.setState({ createdPasswordLink: result.passwordLink });
            return;
        }

        if (outcome === 'no-way-in') {
            notify.warning(Translate('broker-agent/no-way-in/toast'));
            this.setState({ activationFailed: true });
            return;
        }

        notify.success(Translate('broker-agent/create-message'));
        this.closeModal();
    }

    update() {
        let agent = assign({}, this.state.agent);

        agent.firms = agent.firms.map((firm: any) => {
            return firm.id;
        });
        if (this.props.isFromList) {
            this.props.actions
                .updateListBrokerAgent(this.state.agent.id, agent)
                .then(() => {
                    this.setState({ creating: false });
                    notify.success(Translate('broker-agent/edit-message'));
                })
                .catch((errorResponse: any) => {
                    handleError(errorResponse, (errors) => {
                        this.setState({ errors: errors, creating: false });
                    });
                });
        } else {
            agent.parentFirm = this.props.parentFirm;
            this.props.actions
                .updateBrokerAgent(this.state.agent.id, agent)
                .then(() => {
                    this.setState({ creating: false });
                    notify.success(Translate('broker-agent/edit-message'));
                })
                .catch((errorResponse: any) => {
                    handleError(errorResponse, (errors) => {
                        this.setState({ errors: errors, creating: false });
                    });
                });
        }
    }

    closeModal() {
        this.props.onClose(FormValidationService.isEdit(this.props.item.id) && this.state.wasMoved);
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        agent: state.brokers.edit.agent,
        userRoles: Array.isArray(state.brokers.new.userRoles)
            ? state.brokers.new.userRoles
            : Array.isArray(state.brokers.edit.userRoles)
            ? state.brokers.edit.userRoles
            : [],
        availableFirms: Array.isArray(state.brokers.new.availableFirms)
            ? state.brokers.new.availableFirms
            : Array.isArray(state.brokers.edit.availableFirms)
            ? state.brokers.edit.availableFirms
            : [],
        parentFirm: state.brokers.new.parentFirm
            ? state.brokers.new.parentFirm
            : state.brokers.edit.parentFirm
            ? state.brokers.edit.parentFirm
            : {},
        user: state.user,
        availableLanguages: Array.isArray(state.brokers.new.availableLanguages)
            ? state.brokers.new.availableLanguages
            : Array.isArray(state.brokers.edit.availableLanguages)
            ? state.brokers.edit.availableLanguages
            : [],
        site: state.site
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            editBrokerAgent: (id: number) => dispatch(brokerAgentActions.editBrokerAgent(id)),
            updateBrokerAgent: (id: number, agent: any) =>
                dispatch(brokerAgentActions.updateBrokerAgent(id, agent)),
            newBrokerAgent: (id: number) => dispatch(brokerAgentActions.newBrokerAgent(id)),
            createBrokerAgent: (data: any) => dispatch(brokerAgentActions.createBrokerAgent(data)),
            createListBrokerAgent: (data: any) =>
                dispatch(brokerAgentActions.createBrokerListAgent(data)),
            updateListBrokerAgent: (id: number, agent: any) =>
                dispatch(brokerAgentActions.updateBrokerListAgent(id, agent)),
            sendAgentPasswordLink: (id: number, sendMail: boolean) =>
                dispatch(brokerAgentActions.sendAgentPasswordLink(id, sendMail))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AgentModal);
